import React from 'react';
import { Box, Button } from '@mui/material';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import { AmountKey } from './amount';
import { COLORS } from './theme';

/** Register layout: digits, a `00` key, and backspace. No decimal point
 *  — the accumulator shifts as you type, so there's nothing to place. */
const KEYS: AmountKey[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '00', '0', 'back'];

type Props = {
  onKey: (key: AmountKey) => void;
  /** Row height. The cash dialog sits beside a change display and can
   *  afford less. */
  keyHeight?: number;
};

const Keypad: React.FC<Props> = ({ onKey, keyHeight = 72 }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
    {KEYS.map((key) => (
      <Button
        key={key}
        variant="outlined"
        onClick={() => onKey(key)}
        // Keypad presses must not steal focus from the name field —
        // the cashier alternates between typing a name and tapping
        // digits, and a focus jump mid-word loses keystrokes.
        onMouseDown={(e) => e.preventDefault()}
        aria-label={key === 'back' ? 'Backspace' : key}
        sx={{
          height: keyHeight,
          fontSize: '1.6rem',
          fontWeight: 700,
          color: COLORS.text,
          borderColor: COLORS.border,
          backgroundColor: COLORS.surface,
          '&:hover': { borderColor: COLORS.accent, backgroundColor: '#f1f5f9' },
        }}
      >
        {key === 'back' ? <BackspaceOutlinedIcon /> : key}
      </Button>
    ))}
  </Box>
);

export default Keypad;
